<template ref="foo">
  <div>
    <div class="section-title mb-3">View Seat Layout</div>

    <div class="white-wrapper p-3">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center">
            <h6>{{ screenDetails.screen_name }}</h6>
          </div>
        </div>

        <header class="cinema-header">
          <div class="row justify-content-between">
            <div class>
              <div class="d-flex justify-content-end align-items-center">
                <div
                  v-for="(seatType, seatTypeIndex) in seatTypes"
                  :key="'seatType-' + seatTypeIndex"
                  class="mx-1 mx-xl-2"
                  v-on:click="selectSeatType(seatType)"
                >
                  <div
            :class="seatTypeSelected == seatType && seatTypeSelectionMode == 'seatType' ? 'selected_seat_type_active' : ''"
            v-if="seatType.imageURL"
              class="cinema-seat my-0 mx-auto bg-blue"
            >
            <img :src="seatType.imageURL" height="28" width="27" />
            </div>
            <div
            v-else
            :class="seatTypeSelected == seatType && seatTypeSelectionMode == 'seatType' ? `selected_seat_type_active ${seatType.imageClass}` : `${seatType.imageClass}`"
              class="cinema-seat my-0 mx-auto bg-blue"
            >
            </div>
                  <small>{{ $tc(seatType.seatName, "1") }}</small>
                </div>

                <div class="divider mx-1 mx-xl-3"></div>
                <div
                  v-for="(
                    singleScreenType, singleScreenTypeIndex
                  ) in screenSeatTypes"
                  :key="'singleScreenType-' + singleScreenTypeIndex"
                  class="mx-1"
                >
                  <div
                    class="rbg-color"
                    :class="screenSeatTypeSelected == singleScreenType && seatTypeSelectionMode == 'screenSeatType' ? 'selected_screen_type_active' : ''"
                    :style="{
                      borderColor: singleScreenType.sst_seat_color_code,
                      backgroundColor: singleScreenType.sst_seat_color_code,
                      color: 'white',
                    }"
                  ></div>
                  <div>{{ singleScreenType.sst_seat_type }}</div>

                  <!-- <b-button
                    variant="default"
                    class="btn-outline-blue"
                    :style="{ borderColor: singleScreenType.sst_seat_color_code, backgroundColor: singleScreenType.sst_seat_color_code,color: 'white'}"
                  >{{ singleScreenType.sst_seat_type}}</b-button>-->
                </div>
                <!-- 
                <div class="mx-1">
                  <b-button variant="default" class="btn-outline-blue">Silver</b-button>
                </div>

                <div class="mx-1">
                  <button class="btn-outline-blue">Premium</button>
                </div>-->

                <div class="mx-1">
                  <button
                    v-on:click="showName = !showName"
                    :class="showName ? 'btn-blue' : 'btn-outline-blue'"
                  >
                    Show {{ showName ? "Grid" : "Name" }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div class="col-12">
          <h5 class="text-center pt-3">{{ $t("screen_title") }}</h5>
          <div class="cinema-seatlayout">
            <table class="generateSeatLayout">
              <!-- REGULAR SEATS -->

              <!-- SLIVER CLASS LABEL -->
              <!-- <tr>
                <td colspan="22">
                  <b-button variant="default" class="btn-blue mb-3">View Seat No.</b-button>
                </td>
              </tr>-->

              <!-- <tr>
                  <td>
                    <div  class="text-center lh-1">0</div>
                  </td>
                  <td>
                    <div class="cinema-seatNumber">1</div>
                     <div v-on:click="onClickSeat()" class="pos-seat"></div>
                  </td>
                  <td>
                      <div class="cinema-seatNumber">2</div>
                     <div v-on:click="onClickSeat()" class="pos-seat"></div>
                  </td>
                   <td v-for="(loop , regularSeats) in 18+3" :key="regularSeats" v-if="regularSeats >=3">
                     <div class="cinema-seatNumber">{{regularSeats}}</div>
                    <div  class="cinema-seat"></div>
                  </td>
                  <td>
                    <div  class="text-center lh-1">0</div>
                  </td>
              </tr>-->

              <tr v-for="(row, rowIndex) in seats" :key="'row' + rowIndex">
                <!-- <tr v-for="(row, rowIndex) in parseInt(rows)" :key="rowIndex"> -->
                <td>
                  <!-- <div class="cinema-seatName">{{String.fromCharCode(rowIndex+65)}}</div> -->
                  <div class="cinema-seatName">
                    {{
                      seatName[rowIndex].includes("XXX-")
                        ? ""
                        : seatName[rowIndex]
                    }}
                  </div>
                </td>
                <td
                  v-for="(column, columnIndex) in row"
                  :key="'singleSeat' + columnIndex + 1"
                  colspan="1"
                >
                  <!-- :colspan="seats[row][singleSeat].seatType == 'love-seat'? 2 : 1" -->
                  <div
                    :class="
                      seats[rowIndex][columnIndex].seatTypeImageClass ==
                      'no-seat'
                        ? 'd-none'
                        : ''
                    "
                    class="cinema-seatNumber"
                  >
                    {{ seats[rowIndex][columnIndex].seatName }}
                    <!-- {{columnIndex + 1}} -->
                  </div>
                  <div
                    v-if="
                      !showName &&
                      seats[rowIndex] &&
                      seats[rowIndex][columnIndex]
                    "
                    class="cinema-seat"
                    :style="{
                      borderColor:
                        seats[rowIndex][columnIndex].screenSeatType
                          .sst_seat_color_code,
                      backgroundColor:
                        seats[rowIndex][columnIndex].screenSeatType
                          .sst_seat_color_code,
                      backgroundColor:
                        seats[rowIndex][columnIndex].screenSeatType
                          .sst_seat_color_code,
                    }"
                    :class="seats[rowIndex][columnIndex].seatType && seats[rowIndex][columnIndex].seatType.imageURL ? 
                    '' : seats[rowIndex][columnIndex].seatType.imageClass
                  "
                  >
                   <img v-if="seats[rowIndex][columnIndex].seatType.imageURL" :src="seats[rowIndex][columnIndex].seatType.imageURL" height="28" width="27" />
                  </div>
                   <!-- :class="
                    
                      seats[rowIndex][columnIndex].seatTypeImageClass ==
                      'no-seat'
                        ? 'd-none'
                        : seats[rowIndex][columnIndex].seatTypeImageClass
                    " -->
                  <!-- :class="seats[rowIndex][columnIndex].seatTypeImageClass == 'no-seat' ? 'd-none' : seats[rowIndex][columnIndex].seatType.imageClass" -->
                  <!-- style="border-color: goldenrod; background-color: goldenrod;" -->
                  <input
                    v-if="showName"
                    type="text"
                    disabled
                    class="changeSeatName"
                    v-model="seats[rowIndex][columnIndex].seatName"
                  />
                  <!-- {{seats[rowIndex][columnIndex]}} -->
                  <!-- :class="seats[row][column].seatTypeImageClass" -->

                  <!-- v-bind:class="{ 'vip-seat': singleSeat.seatTypeImageClass, 'normal-seat': singleSeat.seatTypeImageClass }" -->
                </td>

                <div class="cinema-seatName">
                  {{
                    seatName[rowIndex].includes("XXX-")
                      ? ""
                      : seatName[rowIndex]
                  }}
                </div>
              </tr>
            </table>
          </div>
        </div>

        <div class="col-12 py-2 text-center">
          <!-- to="add-seat-layout" -->
          <b-button
            variant="default"
            to="/cinema-manager/seat-layout"
            class="btn-black"
            >{{ $t("back") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScreenService from "@/services/ScreenService";
import MasterService from "@/services/MasterService";
import { groupBy } from "lodash";
import { decryptString } from "@/helper/collection"

var thing = {
  data() {
    return {
      screenDetails: {
        screen_name: null,
      },

      showName: false,
      screenId: null,
      screenSeatTypes: [],
      seatTypeSelectionMode: '',
      screenSeatTypeSelected: '',
      seatTypeSelected: {
        seatName: "regularSeat",
        size: 1,
        imageClass: "regular-seat",
      },
      mouseDownStatus: false,
      initialSeatValueSelected: {
        row: 0,
        column: 0,
      },
      finalSeatValueSelected: {
        row: 0,
        column: 0,
      },
     seatTypes: [
        {
          seatName: "Regular Seat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
          imageURL: ''
        },
        {
          seatName: "No Seat",
          size: 1,
          value: 2,
          imageClass: "no-seat",
          imageURL: ''
        },
        {
          seatName: "Wheel Chair",
          size: 1,
          value: 3,
          imageClass: "wheelchair",
          imageURL: ''
        },
        {
          seatName: "VIP Seat",
          size: 1,
          value: 5,
          imageClass: "vip-seat",
          imageURL: ''
        },
        // {
        //   seatName: "Couple Seats",
        //   size: 6,
        //   imageClass: "love-seat",
        // },
        {
          seatName: "Only POS",
          size: 1,
          value: 9,
          imageClass: "pointofsale",
          imageURL: ''
        },
        {
          seatName: "Sofa",
          size: 1,
          value: 10,
          imageClass: "sofa-seat",
          imageURL: ''
        },
        {
          seatName: "Recliner",
          size: 1,
          value: 11,
          imageClass: "recliner",
          imageURL: ''
        },
        // {
        //   seatName: "Blocked Seat",
        //   size: 1,
        //   value: 12,
        //   imageClass: "block-seat",
        // },
        {
          seatName: "Broken Seat",
          size: 1,
          value: 13,
          imageClass: "broken-seat",
          imageURL: ''
        }
      ],
      rows: 10,
      columns: 10,
      seats: [],
      seatName: [],
      activeSeatTypes: [],
      currentCinemaId: null
      // "vipSeat", "regularSeat", "NoSeat", "WheelChair"],
    };
  },
  beforeMount() {
    // this.onChangeRowsColumns();
     const { cinema_id = null } = this.$route.query;
        if (!cinema_id) {
          this.$toasted.show("Cinema is missing")
          this.$router.push("/cinema-manager/screens")
        }
        this.currentCinemaId = decryptString(String(cinema_id))
    this.getSeatTypes();
  },
  mounted() {
    this.screenId = this.$route.params.screenID;
    this.getSeatScreenType();
  },
  methods: {
    checkMouseOver() {
      if(this.seatTypeSelected && this.seatTypeSelected.hasOwnProperty('size') && this.seatTypeSelected.size > 1) {
        return true;
      } else {
        return false;
      }
    },
      getSeatTypes: function(screen) {
      let payload = {
        tableName: "ms_seat_reserve_types",
        srt_is_active: "Y"
      };
      this.seatTypes = [];
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.activeSeatTypes = data.Records;
            this.activeSeatTypes.map((x) => {
              let obj = {
                seatName: x.srt_name,
                size: x.srt_seat_capacity,
                value: x.srt_id,
                imageClass: "regular-seat",
                imageURL: this._GetImagePath(x.srt_dash_image_url)
              }
              if(x.srt_id == 1) {
                this.seatTypeSelected = obj
              }
              this.seatTypes.push(obj)
            })
          } else {
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("Catch Error :", error);
        });
    },
    getSeatScreenType: function () {
      let payload = {
        screenID: this.screenId,
        cinema_id:this.currentCinemaId
      };
      ScreenService.getSeatScreenType(payload)
        .then((result) => {
          const { data } = result;
          if (data.status && data.Records.length > 0) {
            this.screenSeatTypes = data.Records;
            this.getSeatLayout();
          }
        })
        .catch((err) => {});
    },
    getSeatLayout: function () {
      let payload = {
        screenID: this.screenId,
        cinema_id:this.currentCinemaId
      };
      ScreenService.getSeatLayout(payload)
        .then((result) => {
          // console.log("result :", result);
          const { data } = result;
          if (data.status && data.Records.screen_layouts.length > 0) {
            this.screenDetails =
              data.Records["screenDetails"] &&
              data.Records.screenDetails.length > 0
                ? data.Records.screenDetails[0]
                : this.screenDetails;

            let seatData_1 = groupBy(data.Records.screen_layouts, "sl_row_num");
            for (let key in seatData_1) {
              let count33 = 0;
              if (seatData_1.hasOwnProperty(key)) {
                let seatData_2 = seatData_1[key].map((singleSeat) => {
                  singleSeat["seatName"] = singleSeat.sl_seat_name;

                  var answer = singleSeat.sl_seat_name;
                  if(answer.includes("-")) {
                   answer = answer.split('-')[0] + '-';
                  } else {
                    answer = answer.replace(/[^a-z]/gi, "");
                  }
                  let indexNew = this.seatName.indexOf(answer);
                  if (indexNew < 0 && answer) {
                    this.seatName.push(answer);
                    count33++;
                  }

                  //  else if (
                  //   this.seatName.indexOf("XXXXXX" + key) < 0 &&
                  //   indexNew < 0
                  // ) {
                  //   this.seatName.push("XXXXXX" + key);
                  // }

                  this.seatTypes.map((x) => {
                    if (x.value == singleSeat.seat_reserve_type_id) {
                      singleSeat["seatTypeImageClass"] = x.imageClass;
                      singleSeat["imageURL"] = x.imageURL;
                      singleSeat["seatType"] = x;
                    }
                    this.screenSeatTypes.map((y) => {
                      if (y.sst_id == singleSeat.screen_seat_type_id) {
                        singleSeat["screenSeatType"] = y;
                      }
                    });
                  });
                  return singleSeat;
                });
                if (count33 == 0) {
                  this.seatName.push("XXX-" + key);
                }
                this.seats.push(seatData_2);
              }
            }
          }
          console.log(this.seats, this.seatName);

          // console.log("tempArray_1 :", tempArray_1);
          // this.seats = data.data;
        })
        .catch((err) => {});
    },
    onChangeRowsColumns: function () {
      console.log("test");
      this.seats = [];
      var seatRow = [];
      for (let i = 0; i < this.rows; i++) {
        seatRow = [];
        for (let j = 0; j < this.columns; j++) {
          seatRow.push({
            seatType: "normal",
            seatTypeImageClass: "normal-seat",
            seatName: String.fromCharCode(i + 65) + parseInt(j + 1),
            anyOtherData: "test",
          });
        }
        this.seats.push(seatRow);
        console.log(this.seats, seatRow);
      }
    },
    selectSeatType: function (seatType) {
      console.log(seatType);
      this.seatTypeSelected = seatType;
      this.seatTypeSelectionMode = "seatType";
    },
    selectScreenSeatType: function (seatScreenType) {
      console.log(seatScreenType);
      this.screenSeatTypeSelected = seatScreenType;
      this.seatTypeSelectionMode = "screenSeatType";
    },
  },
};
global.thing = thing;
export default thing;
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/CinemaSeatLayoutComponents/viewSeatLayout.vue